import React from 'react';
import SEO from '../SEO/SEO';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import NewsletterSignup from '../NewsletterSignup/NewsletterSignup';
import '../Styles/reset.css';
import '../Styles/utils.css';
import '../Styles/layout.css';

function CookiePolicy() {
    return (
        <div>
            <SEO
                title="Cookie Policy - Smart Life Choice"
                description="Learn about how Smart Life Choice uses cookies to improve your browsing experience. Understand what cookies we use and how to manage them."
                url="/cookie-policy"
                keywords="cookie policy, cookies, website cookies, tracking, browser cookies, cookie management"
            />
            <Header />

            <main className="main">
                <div className="container">
                    <section className="policy-section" style={{
                        maxWidth: '900px',
                        margin: '0 auto',
                        padding: '2rem 1rem'
                    }}>
                        <h1 style={{
                            fontSize: '2.5rem',
                            fontWeight: '700',
                            marginBottom: '1rem',
                            color: 'var(--color-primary)'
                        }}>Cookie Policy</h1>

                        <div style={{
                            fontSize: '0.95rem',
                            color: 'var(--color-gray-600)',
                            marginBottom: '2rem',
                            paddingBottom: '1rem',
                            borderBottom: '2px solid var(--color-gray-200)'
                        }}>
                            <p><strong>Effective Date:</strong> 10 November 2025</p>
                        </div>

                        <div style={{
                            lineHeight: '1.8',
                            fontSize: '1.05rem',
                            color: 'var(--color-gray-800)'
                        }}>
                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>1. What Are Cookies?</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                Cookies are small files stored on your device that help us improve user experience,
                                analyze traffic, and show relevant ads.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>2. Types of Cookies We Use</h2>
                            <ul style={{
                                marginLeft: '2rem',
                                marginBottom: '1.5rem',
                                listStyle: 'disc'
                            }}>
                                <li style={{ marginBottom: '0.75rem' }}>
                                    <strong>Essential Cookies:</strong> Required for website functionality
                                </li>
                                <li style={{ marginBottom: '0.75rem' }}>
                                    <strong>Analytics Cookies:</strong> Help us understand visitor behavior (via Google Analytics)
                                </li>
                                <li style={{ marginBottom: '0.75rem' }}>
                                    <strong>Advertising Cookies:</strong> Used by Google AdSense and affiliates to show relevant ads
                                </li>
                            </ul>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>3. Managing Cookies</h2>
                            <p style={{ marginBottom: '1.5rem' }}>
                                You can accept or reject cookies using the pop-up banner or by adjusting your browser settings.
                                Disabling cookies may affect some features of the site.
                            </p>

                            <h2 style={{
                                fontSize: '1.75rem',
                                fontWeight: '600',
                                marginTop: '2.5rem',
                                marginBottom: '1rem',
                                color: 'var(--color-gray-900)'
                            }}>4. Third-Party Cookies</h2>
                            <p style={{ marginBottom: '1rem' }}>
                                Third parties like Google may use cookies to deliver personalized ads.
                                You can learn more about how Google uses data here:
                            </p>
                            <p style={{ marginBottom: '1.5rem' }}>
                                <a href="https://policies.google.com/technologies/ads"
                                   target="_blank"
                                   rel="noopener noreferrer"
                                   style={{
                                       color: 'var(--color-primary)',
                                       textDecoration: 'underline'
                                   }}>
                                    https://policies.google.com/technologies/ads
                                </a>
                            </p>
                        </div>
                    </section>
                </div>

                <NewsletterSignup />
            </main>

            <Footer />
        </div>
    );
}

export default CookiePolicy;
